import Vue from 'vue'
import moment from 'moment'

Vue.filter('date', (value, format = 'DD/MMM/YYYY', plus) => moment(value).add(plus, 'days').format(format))

Vue.filter('dateAndHour', value => moment(value).format('HH:mm:ss DD/MMM/YYYY'))
